import { Link, UriLocation } from "../../../types/link";

export function extractRelName(link: Link): string {
  return link.rel.split("/").pop() as string;
}

function getLocation(uri: string): UriLocation {
  const match = uri.match(
    /^(https?:)\/\/(([^:/?#]*)(?::([0-9]+))?)([/]{0,1}[^?#]*)(\?[^#]*|)(#.*|)$/,
  );
  if (!match) {
    throw Error(`Malformed URI: ${uri}`);
  }
  return {
    protocol: match[1],
    host: match[2],
    hostname: match[3],
    port: match[4],
    pathname: match[5],
    origin: `${match[1]}//${match[2]}`,
  };
}

function getOrigin(): string {
  return getLocation(window.location.href).origin;
}

function addHostnameToUri(uri: string): string {
  return getOrigin() + uri;
}

function findLink(name: string, links: Array<Link>): Link {
  const match = links.find((l) => {
    return (l.name && l.name === name) || extractRelName(l) === name;
  });

  if (!match) {
    throw new Error(
      `Link ${name} not found in [${links.map((l) => l.rel).join(",")}]`,
    );
  }

  return match;
}

export function linkExist(name: string, links: Array<Link>): boolean {
  try {
    return findLink(name, links).uri !== undefined;
  } catch (err) {
    return false;
  }
}

export function findURIWithWindowHostname(
  name: string,
  links: Array<Link>,
): string {
  const uri = findLink(name, links).uri;
  const pathname = getLocation(uri).pathname;
  return addHostnameToUri(pathname);
}
